export const camelCase = (str) => {
    return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, "")
        .replace(/-/g, "");
};

export const toString = (value) => {
    return ((null !== value) && (undefined !== value)) ? String(value) : '';
}

export const truncate = (str, length = 130) => {
    return str.length > length ? str.substring(0, length) + "..." : str;
}
